import { Hint } from '@/shared/design-system/thermal-ceramics/components/form/hint';
import classNames from './styles.module.css';

export const RequiredHint = () => <Hint className={classNames.hint}>* indicates a required field</Hint>;